<ng-container>
    <mat-toolbar class="bottom-nav">
        <ng-container *ngIf="(navigation$ | async) as navigation">
          <ng-container *ngFor="let item of navigation; let i = index">
            <div (click)="decideRouteOrDialog(item.url)" class="item-box" fxLayout="column" fxLayoutGap="4" fxLayoutAlign="center center">
              <div class="icon-container" [class.active]="isRouteActive(item.url)">
                <mat-icon>{{ item.icon }}</mat-icon>
              </div>
              <span class="label-medium">{{ getBottomNavLabel(item.title) }}</span>
            </div>
          </ng-container>
        </ng-container>
      </mat-toolbar>
</ng-container>
